/**
 * Type resolution + launcher metadata — no defaults or migration logic.
 */
import { BLOCK_TYPE_ALIASES, resolveBlockType as resolveBlockTypeCore } from './block-type-resolve'
import { BLOCKS_REGISTRY } from './blocks-registry-entries'

export { BLOCK_TYPE_ALIASES }
export { LEGACY_TO_BLOCK } from './block-type-resolve'

const REGISTRY_KEY_SET = new Set(Object.keys(BLOCKS_REGISTRY))

/** All block type ids — used by API validation (includes legacy aliases) */
export const BLOCK_TYPE_IDS = [
  ...Object.keys(BLOCKS_REGISTRY),
  ...Object.keys(BLOCK_TYPE_ALIASES),
]

const LAUNCHER_PRIORITY = ['block_richtext', 'block_media', 'block_card']

export const BLOCK_LAUNCHER_ENTRIES = Object.values(BLOCKS_REGISTRY)
  .filter((e) => !e.launcherHidden)
  .sort((a, b) => {
    const ai = LAUNCHER_PRIORITY.indexOf(a.type)
    const bi = LAUNCHER_PRIORITY.indexOf(b.type)
    if (ai !== -1 && bi !== -1) return ai - bi
    if (ai !== -1) return -1
    if (bi !== -1) return 1
    return a.label.localeCompare(b.label)
  })
  .map((e) => ({
    type: e.type,
    label: e.label,
    desc: e.description,
    category: e.launcherCategory,
    icon: e.icon,
    comingSoon: false,
    source: 'blocks',
  }))

export function resolveBlockType(type) {
  return resolveBlockTypeCore(type, REGISTRY_KEY_SET)
}

export function isBlockType(type) {
  return Boolean(BLOCKS_REGISTRY[resolveBlockType(type)])
}

export function blockRegistryEntry(type) {
  const resolved = resolveBlockType(type)
  return BLOCKS_REGISTRY[resolved] ?? null
}
